export default "__VITE_ASSET__BJNSWQDs__"